const STARS = [1, 2, 3, 4, 5] as const;

interface StarRatingProps {
  name: string;
  legend: string;
  value: number | undefined;
  required?: boolean;
  error?: string;
  onChange: (value: number) => void;
}

export function StarRating({ name, legend, value, required, error, onChange }: StarRatingProps) {
  const errorId = `${name}-error`;
  return (
    <fieldset
      className="space-y-2"
      aria-describedby={error ? errorId : undefined}
      aria-invalid={Boolean(error)}
    >
      <legend className="field-label mb-2">
        {legend}
        {required ? <span className="text-crimson"> *</span> : null}
      </legend>
      <div className="flex flex-wrap gap-2">
        {STARS.map((star) => {
          const selected = value !== undefined && star <= value;
          return (
            <label
              key={star}
              className={`inline-flex min-h-11 min-w-11 cursor-pointer items-center justify-center rounded-none border text-2xl ${
                selected
                  ? 'border-crimson bg-crimson text-white'
                  : 'border-linen bg-white text-charcoal'
              }`}
            >
              <input
                className="sr-only"
                type="radio"
                name={name}
                value={star}
                checked={value === star}
                onChange={() => onChange(star)}
              />
              <span aria-hidden="true">★</span>
              <span className="sr-only">
                {star} star{star === 1 ? '' : 's'}
              </span>
            </label>
          );
        })}
      </div>
      {error ? (
        <p className="text-sm font-semibold text-crimson" id={errorId} role="alert">
          {error}
        </p>
      ) : null}
    </fieldset>
  );
}
